// For a patient already in Treatment: without a start, a week counted from it can never fire.
export const NO_TREATMENT_START_ON_RECORD = 'No Treatment-phase start on record';

// The API refuses "from now" on a refinement's next series, whose weeks restart with it.
export const NEXT_SERIES_COUNTS_FROM_TREATMENT_START =
    "The next series' weeks count from its treatment start";
